import { render, staticRenderFns } from "./Paired.vue?vue&type=template&id=45b31ce5&"
import script from "./Paired.vue?vue&type=script&lang=js&"
export * from "./Paired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports